// ── HEADER SCROLL STATE (blur più forte allo scroll) ───────────
(function () {
  var header = document.querySelector('header');
  if (!header) return;
  var ticking = false;
  function update() {
    if (window.scrollY > 12) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
  update();
})();

// ── STAGGER FADE-UP DELLE CARD (IntersectionObserver) ──────────
(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var selectors = '.product-card, .lookbook-item, .category-banner, .promo-card, .section-header, .brand-story-image, .brand-story-text';
  var groups = {}; // raggruppa gli elementi per genitore, per calcolare lo stagger

  document.querySelectorAll(selectors).forEach(function (el) {
    var parent = el.parentElement;
    var key = parent ? (parent.className || 'root') : 'root';
    if (!groups[key]) groups[key] = [];
    groups[key].push(el);
  });

  Object.keys(groups).forEach(function (key) {
    groups[key].forEach(function (el, i) {
      el.classList.add('fade-up-init');
      // calcola un piccolo delay scaglionato in base alla posizione nella griglia
      var delay = Math.min(i % 8, 8) * 70;
      el.style.transitionDelay = delay + 'ms';
    });
  });

  if (!('IntersectionObserver' in window)) {
    // Fallback: mostra tutto immediatamente
    document.querySelectorAll('.fade-up-init').forEach(function (el) {
      el.classList.add('fade-up-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-up-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.fade-up-init').forEach(function (el) {
    observer.observe(el);
  });
})();

// ── PARALLAX LEGGERO SULL'HERO ──────────────────────────────────
(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroImg = document.querySelector('.hero-img');
  var heroEditorial = document.querySelector('.hero-editorial');
  var hero = document.querySelector('.hero');
  if (!hero || prefersReducedMotion) return;

  var ticking = false;
  function updateParallax() {
    var rect = hero.getBoundingClientRect();
    // Applica il parallax solo quando l'hero è visibile in viewport
    if (rect.bottom > 0 && rect.top < window.innerHeight) {
      var progress = -rect.top * 0.12; // velocità leggera
      if (heroImg) heroImg.style.transform = 'translateY(' + progress + 'px)';
      if (heroEditorial) heroEditorial.style.transform = 'translate(-50%, calc(-50% + ' + (progress * 0.4) + 'px))';
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }, { passive: true });
  updateParallax();
})();

// ── RIPPLE EFFECT SUI PULSANTI (vanilla, senza dipendenze) ──────
(function () {
  var rippleSelector = '.btn-primary, .btn-dark, .quick-add, .email-submit, .pagination-btn, .cart-btn';
  document.addEventListener('click', function (e) {
    var target = e.target.closest(rippleSelector);
    if (!target) return;
    // Evita ripple su elementi disabilitati o in stato "unavailable"
    if (target.classList.contains('quick-add--unavailable')) return;

    var rect = target.getBoundingClientRect();
    var ripple = document.createElement('span');
    var size = Math.max(rect.width, rect.height);
    ripple.className = 'ripple';
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';

    var computedPosition = window.getComputedStyle(target).position;
    if (computedPosition === 'static') {
      target.style.position = 'relative';
    }
    target.appendChild(ripple);
    setTimeout(function () {
      ripple.remove();
    }, 650);
  });
})();


function toggleMobileMenu(btn) {
  var nav = document.getElementById('mobileNav');
  if (!nav) return;
  var isOpen = nav.classList.toggle('open');
  btn && btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  btn && btn.classList.toggle('active', isOpen);
}

// Close mobile menu on link click
document.addEventListener('DOMContentLoaded', function () {
  var mobileLinks = document.querySelectorAll('.mobile-nav a');
  mobileLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      var nav = document.getElementById('mobileNav');
      var btn = document.querySelector('.hamburger');
      if (nav) nav.classList.remove('open');
      if (btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Close mobile menu clicking outside
  document.addEventListener('click', function (e) {
    var nav = document.getElementById('mobileNav');
    var hamburger = document.querySelector('.hamburger');
    if (nav && nav.classList.contains('open')) {
      if (!nav.contains(e.target) && !hamburger.contains(e.target)) {
        nav.classList.remove('open');
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    }
  });
});

// ── NEWSLETTER SIGNUP ─────────────────────────────────────────
function handleSubscribe(e) {
  e.preventDefault();
  var input = e.target.querySelector('input[type="email"]');
  if (!input || !input.value || !input.validity.valid) {
    input && input.focus();
    return;
  }
  var form = document.getElementById('emailForm');
  var success = document.getElementById('emailSuccess');
  if (form) form.style.display = 'none';
  if (success) success.style.display = 'block';
}

// ── QUICK ADD TO CART (usata anche da collection.liquid) ──────
function quickAddToCart(e, variantId, productUrl) {
  e.preventDefault();
  e.stopPropagation();

  var btn = e.currentTarget;
  if (!variantId || btn.classList.contains('loading')) return;

  // Se ha varianti multiple → vai alla pagina prodotto
  var card = btn.closest('.product-card');
  if (card && card.querySelectorAll('.color-dot').length > 0) {
    window.location.href = productUrl;
    return;
  }

  var originalText = btn.textContent;
  btn.classList.add('loading');
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
      cache: 'no-store',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function (res) { return res.json(); })
  .then(function (data) {
    btn.classList.remove('loading');
    if (data.status) {
      // Errore (es. esaurito) → vai alla pagina prodotto
      window.location.href = productUrl;
    } else {
      // FIX: usare innerHTML (non textContent) per renderizzare l'SVG invece di mostrarlo come testo grezzo
      btn.innerHTML = '<svg style="display:inline-block;vertical-align:middle;width:1em;height:1em;margin-right:4px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Aggiunto!';
      btn.classList.add('added');
      updateCartCount();
      setTimeout(function () {
        btn.textContent = originalText;
        btn.classList.remove('added');
      }, 2500);
    }
  })
  .catch(function () {
    btn.classList.remove('loading');
    window.location.href = productUrl;
  });
}

// Aggiorna il contatore carrello nell'header
function updateCartCount() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badge = document.querySelector('#cartBtn .cart-count');
      var cartBtn = document.getElementById('cartBtn');
      if (!cartBtn) return;
      if (cart.item_count > 0) {
        if (badge) {
          badge.textContent = cart.item_count;
        } else {
          var span = document.createElement('span');
          span.className = 'cart-count';
          span.textContent = cart.item_count;
          cartBtn.appendChild(span);
        }
      } else {
        if (badge) badge.remove();
      }
    })
    .catch(function () {});
}

// ── SORT COLLECTION ───────────────────────────────────────────
function sortCollection(value) {
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', value);
  window.location.href = url.toString();
}

// ── CONTACT FORM FALLBACK (per anteprima non-Shopify) ─────────
function handleContact(e) {
  e.preventDefault();
  e.target.style.display = 'none';
  var el = document.getElementById('contactSuccess');
  if (el) el.style.display = 'block';
}

// ── MOBILE ACCORDION ──────────────────────────────────────────
function toggleMobileAccordion(btn) {
  var content = btn.nextElementSibling;
  var isOpen = btn.getAttribute('aria-expanded') === 'true';

  // Chiudi tutti gli altri accordion aperti
  document.querySelectorAll('.mobile-accordion-toggle').forEach(function(b) {
    if (b !== btn) {
      b.setAttribute('aria-expanded', 'false');
      var c = b.nextElementSibling;
      if (c) c.classList.remove('open');
    }
  });

  // Toggle questo
  if (isOpen) {
    btn.setAttribute('aria-expanded', 'false');
    content.classList.remove('open');
  } else {
    btn.setAttribute('aria-expanded', 'true');
    content.classList.add('open');
  }
}
